module.exports = __webpack_public_path__ + "img/thumbnail_Springbok_j_albino.a200fbaa.png";